import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "../views/Template/Auth";
import Maqueta from "../views/Template/Maqueta";
import templateIframe from "@/views/Template/template-iframe";
import maquetaCreate from "../views/Template/maquetaCreate";
import LayoutProperty from "@/views/layouts/LayoutProperty.vue";
import maquetaApp from "../views/Template/App";
import store from "../store/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/auth/:provider/callback",
    component: {
      template: '<div class="auth-component"></div>',
    },
  },
  {
    path: "/verific/token/account/:token",
    name: "Confirmar",
    props: true,
    component: () => import("@/views/Template/Auth/Confirmar.vue"),
  },

  {
    // Acceso directo (impersonación) desde el panel de administración.
    path: "/acceso-directo",
    name: "AccesoDirecto",
    component: () => import("@/views/Template/Auth/AccesoDirecto.vue"),
  },

  {
    path: "/",
    component: Auth,

    children: [
      {
        path: "/",
        name: "Login",
        component: () => import("@/views/Template/Auth/Login.vue"),
        // Los enlaces de "Recomienda y gana" son la raíz con ?ref=CODIGO: quien llega
        // sin sesión va directo al alta, que pone el código sola.
        beforeEnter: (to, from, next) => {
          if (to.query.ref && !store.getters.loggedIn) {
            return next({ name: "Register", query: { ref: String(to.query.ref) } });
          }
          next();
        },
      },
      {
        // El alta de cuenta ya no es pública: no se anuncia en el login ni se
        // enlaza desde ninguna parte. Sigue viva, pero en una dirección que hay
        // que conocer, porque el alta pasa por nosotros. La dirección antigua
        // sigue justo debajo, pero ya no trae aquí.
        path: "/guided-register",
        name: "Register",
        component: () => import("@/views/Template/Auth/Register.vue"),
      },
      {
        // Quien llegue con la dirección vieja guardada no se encuentra una
        // pantalla en blanco: se le deja en el login, que es donde ya no hay
        // puerta de alta. No es un atajo a la nueva: no lleva a ninguna parte.
        path: "/register",
        redirect: { name: "Login" },
      },
      {
        path: "/reset",
        name: "Reset",
        component: () => import("@/views/Template/Auth/Reset.vue"),
      },

      {
        path: "/recuperar/:token",
        name: "confirmacionReset",
        props: true,
        component: () =>
          import("@/views/Template/Auth/confirmationRecovery.vue"),
        meta: {
          roll: "empresa",
        },
      },
    ],
  },
  {
    path: "/iframe/",
    component: templateIframe,
    children: [
      {
        path: "invoices",
        name: "InvoicesIframe",
        component: () => import("@/views/Business/Facturas/index.vue"),
        children: [
          {
            path: "/iframe/select/suscriptions",
            name: "pageSubscriptionIframe",
            component: () =>
              import("@/views/Business/Subscription/indexIframe.vue"),
          },
        ],
      },
    ],
  },

  {
    // =============================================================================
    // Panel Business
    // =============================================================================
    path: "/business/",
    component: Maqueta,
    children: [
      {
        path: "profile",
        name: "Perfil",
        component: () => import("@/views/miCuentaScreen/index.vue"),
        children: [
          {
            path: "welcome",
            name: "accountWelcome",
            component: () =>
              import("@/views/miCuentaScreen/AccountWelcome.vue"),
          },
          {
            path: "config-account",
            name: "configAccount",
            component: () =>
              import("@/components/account-setup/AccountSettings.vue"),
          },
          {
            path: "config-language",
            name: "configLanguage",
            component: () =>
              import("@/components/account-setup/configuracionIdioma.vue"),
          },

          {
            path: "secure-sesion",
            name: "secureSesion",
            component: () =>
              import("@/components/account-setup/seguridadCuenta.vue"),
          },
          {
            path: "billing",
            name: "Billing",
            component: () =>
              import("@/components/account-setup/facturacionCuenta.vue"),
          },
          {
            path: "payments",
            name: "Payments",
            props: true,
            component: () =>
              import("@/components/account-setup/PaymentsConnect.vue"),
          },
          // Stripe y Wompi son DOS integraciones, no dos opciones de una: cada
          // una tiene su pantalla, con sus cuentas y su reparto de anuncios.
          // Es el mismo componente montado con el proveedor cambiado.
          // (Las pantallas viejas de una sola cuenta, StripeSettings.vue y
          // WompiSettings.vue, siguen en el repo pero ya no se enrutan.)
          {
            path: "payments-stripe",
            name: "stripeSettings",
            props: { provider: "stripe" },
            component: () =>
              import("@/components/account/PaymentAccountsProvider.vue"),
          },
          {
            path: "payments-wompi",
            name: "wompiSettings",
            props: { provider: "wompi" },
            component: () =>
              import("@/components/account/PaymentAccountsProvider.vue"),
          },
          {
            path: "payments-bold",
            name: "boldSettings",
            props: { provider: "bold" },
            component: () =>
              import("@/components/account/PaymentAccountsProvider.vue"),
          },
          {
            path: "payments-redsys",
            name: "redsysSettings",
            props: { provider: "redsys" },
            component: () =>
              import("@/components/account/PaymentAccountsProvider.vue"),
          },
          {
            // Los datáfonos de recepción (cobrar desde la ficha de la reserva).
            path: "datafonos",
            name: "datafonoSettings",
            component: () => import("@/components/account/DatafonosSettings.vue"),
          },
          {
            path: "subscription",
            name: "subscriptionSettings",
            component: () =>
              import("@/components/account-setup/SubscriptionSettings.vue"),
          },
          {
            path: "referrals",
            name: "referralProgram",
            component: () =>
              import("@/views/miCuentaScreen/ReferralProgram.vue"),
          },
          {
            path: "account-invoices",
            name: "InvoicesMenu",
            component: () =>
              import("@/components/account-setup/facturaSuscripcion.vue"),
          },
          {
            path: "purchased-properties",
            name: "PurchasedProperties",
            component: () =>
              import("@/components/account-setup/PurchasedProperties.vue"),
          },
          {
            path: "billing-configuration",
            name: "BillingConfiguration",
            component: () =>
              import("@/components/account/BillingConfiguration.vue"),
          },

          // ── Gestión de equipo (dentro del layout de miCuentaScreen) ──
          {
            path: "team-management",
            name: "GestionEquipo",
            component: () => import("@/views/Business/Team/GestionEquipo.vue"),
            meta: { requiresAuth: true },
          },

          // ── Acciones del Sistema (dentro del layout de miCuentaScreen) ──
          {
            path: "system-actions",
            component: () =>
              import("@/views/Business/SystemActions/index.vue"),
            children: [
              {
                path: "",
                redirect: { name: "SystemActionFirstCheckin" },
              },
              {
                path: "first-checkin-send",
                name: "SystemActionFirstCheckin",
                component: () =>
                  import("@/views/Business/SystemActions/FirstCheckinSend.vue"),
              },
            ],
          },
          // ─────────────────────────────────────────────────────────────
          // Índice clásico de anuncios (tabla / lista plana)
          // ─────────────────────────────────────────────────────────────
          {
            path: "/account/listing",
            name: "ListingIndex",
            component: () => import("@/views/account/ListingIndex.vue"),
          },

          // ─────────────────────────────────────────────────────────────
          // Detalle de un listing (sub-opciones: Agente IA, etc.)
          // ─────────────────────────────────────────────────────────────
          {
            path: "/account/listing/:listingId",
            name: "ListingDetail",
            component: () => import("@/views/account/ListingDetail.vue"),
            props: true,
          },

          {
            path: "page-chat-bot-ia",
            name: "pageManageChatBot",
            props: true,
            component: () => import("@/views/Business/chatBot/pageIndex.vue"),
          },

          // 3. Configuración del Agente IA para un listing específico
          {
            path: "/account/listing/:listingId/agent-ia",
            name: "ListingBotConfig",
            component: () => import("@/views/account/ListingBotConfig.vue"),
            props: true,
          },

          {
            path: "welcome-accommodation",
            name: "welcomeAccommodation",
            props: true,
            component: () =>
              import("@/components/Propiedades/welcomeAccommodation.vue"),
          },

          {
            path: "authorities",
            name: "Authorities",
            props: true,
            component: () => import("@/components/Propiedades/Autoridades.vue"),
          },
           {
            path: "checkin-programming",
            name: "checkinProgramming",
            props: true,
            component: () =>
              import("@/components/Propiedades/CheckinProgramming.vue"),
          },
          {
            path: "accommodation-policies",
            name: "accommodationPolicies",
            props: true,
            component: () =>
              import("@/components/Propiedades/accommodationPolicies.vue"),
          },

          {
            path: "data-basic-accommodation",
            name: "ImageAccommodation",
            props: true,
            component: () =>
              import("@/components/Propiedades/imageAccommodation.vue"),
          },

          {
            path: "account-waba",
            name: "wabaAccount",
            component: () => import("@/views/Business/WabaIntegration.vue"),
          },
          {
            path: "waba-integration",
            name: "wabaIntegration1",
            component: () => import("@/views/Business/menuIntegration.vue"),
          },
          {
            path: "whatsapp_manager",
            name: "adminTemplates",
            component: () => import("@/views/Business/Templates/index.vue"),
          },
          {
            path: "notifications-settings",
            name: "notificationsSettings",
            component: () =>
              import("@/components/account-setup/NotificationsSettings.vue"),
          },
          {
            path: "connection-channel",
            name: "connectionChannel",
            component: () =>
              import("@/components/account-setup/ConnectionChannel.vue"),
          },
          {
            path: "integrations",
            name: "Integrations",
            component: () => import("@/views/Business/Integrations/index.vue"),
          },
          // Integraciones
          {
            path: "/integrations/pricelabs",
            name: "priceLabsConfig",
            component: () =>
              import("@/components/account-setup/PriceLabsConfig.vue"),
          },
          //
        ],
      },
      {
        path: "whatsapp-mass-communication",
        name: "indexWhatsappCommunication",
        component: () => import("@/views/Business/massiveWhatsApp/index.vue"),
      },
      {
        path: "notificaciones",
        name: "notificacionesUser",
        component: () => import("@/views/Business/Notificaciones/index.vue"),
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/Business/dashboard/Index.vue"),
      },

      // ── GESTOR DE ANUNCIOS — Split layout full-screen. ─────────────
      // Vive directamente bajo Maqueta (no bajo Perfil/miCuentaScreen)
      // para que no renderice el sidebar de configuración de cuenta.
      // Acceso: menú avatar → "Configuración de anuncios".
      // ──────────────────────────────────────────────────────────────
      {
        path: "listings-manager",
        name: "ListingManager",
        component: () => import("@/views/account/ListingManager.vue"),
        meta: { requiresAuth: true },
      },
      // ── AGENTE IA — misma vista que el gestor de anuncios pero
      //    mostrando únicamente las tarjetas del Agente IA.
      // ──────────────────────────────────────────────────────────────
      {
        path: "ai-agent",
        name: "AgentIAManager",
        component: () => import("@/views/account/ListingManager.vue"),
        props: { aiOnly: true },
        meta: { requiresAuth: true },
      },
      // ── AGENTE IA — Página de pruebas (playground de chat) ──────────
      //    Permite conversar con el agente avanzado sin enviar nada por
      //    WhatsApp, eligiendo el anuncio/reserva de contexto.
      // ──────────────────────────────────────────────────────────────
      {
        path: "ai-agent/playground",
        name: "AgentIAPlayground",
        component: () => import("@/views/account/AgentIaPlayground.vue"),
        meta: { requiresAuth: true },
      },
      // ── ASISTENTE DE CONFIGURACIÓN — wizard paso a paso full-screen.
      // ──────────────────────────────────────────────────────────────
      {
        path: "setup-assistant",
        name: "SetupWizard",
        component: () => import("@/views/account/SetupWizard.vue"),
        meta: { requiresAuth: true },
      },
      // ──────────────────────────────────────────────────────────────
      {
        path: "/analytics",
        name: "Analytics",
        component: () => import("@/views/analytics/AnalyticsIndex.vue"),
        meta: { requiresAuth: true },
      },

      {
        path: "checkin-management",
        name: "Bookings",
        component: () => import("@/views/Business/Bookings/index.vue"),
      },
      {
        path: "scheduled-checkins",
        name: "Reservas",
        component: () => import("@/views/Business/Reservas/index.vue"),
      },
      {
        /* Las llamadas que ha atendido la recepción telefónica (agente de voz).
           Va con Reservas y Check-ins, dentro del layout que lleva el menú
           lateral: es una pantalla del panel, no una de pantalla completa. La
           cerradura de verdad está en la API (`contrato:voice_agent`). */
        path: "calls",
        name: "VoiceCalls",
        component: () => import("@/views/Business/Llamadas/VoiceCalls.vue"),
      },
      {
        /* Lo que han pedido los huéspedes al agente. Vivía en un cajón del panel
           de control; de pantalla caben muchas más solicitudes y se pueden
           filtrar y ordenar. Va con Llamadas: las dos son «recepción». */
        path: "ai-reception",
        name: "AgentRequests",
        component: () => import("@/views/Business/RecepcionIA/index.vue"),
      },
      {
        path: "invoices",
        name: "InvoiceList",
        component: () => import("@/views/invoices/InvoiceList.vue"),
      },
      {
        path: "guests",
        name: "GuestList",
        component: () => import("@/views/guest/GuestList.vue"),
      },
      {
        // Directorio de CLIENTES (personas): todo el que hizo check-in y toda ficha
        // de facturación, una sola vez. Los «Clientes fiscales» siguen en GuestList.
        path: "clientes",
        name: "ClientesDirectorio",
        component: () => import("@/views/Business/Clientes/index.vue"),
      },
      {
        path: "housekeeping",
        name: "Housekeeping",
        component: () => import("@/views/Business/Housekeeping/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        // Planificación: las limpiezas FUTURAS y a quién se le encargan. Ruta hermana
        // del tablero de hoy, con la misma función de permisos (ver PERMISO_POR_RUTA).
        path: "housekeeping/plan",
        name: "HousekeepingCalendar",
        component: () => import("@/views/Business/Housekeeping/Calendario.vue"),
        meta: { requiresAuth: true },
      },
      {
        // Editor de un protocolo de limpieza por pasos (tramos + tareas, lista o flujo).
        // Se llega desde Limpieza → Configuración → Modo de limpieza.
        path: "housekeeping/protocolos/:id",
        name: "HousekeepingProtocol",
        component: () => import("@/views/Business/Housekeeping/Protocolo.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "analytics",
        name: "Analytics",
        component: () => import("@/views/Business/Analytics/index.vue"),
      },
      {
        path: "/direct-bookings/settings",
        name: "DirectBookingsSettings",
        component: () =>
          import("@/views/properties/DirectBookingsSettings.vue"),
        meta: {
          title: "Configuración de Reservas Directas",
          requiresAuth: true,
        },
      },

      /*
       * Constructor web. A propósito NO tiene entrada en el menú lateral: se
       * entra escribiendo /websites. La pantalla está entera y funciona; lo
       * que falta es el visto bueno para anunciarla, así que hasta entonces se
       * enseña sólo a quien se le pase el enlace. Cuando toque, la entrada va en
       * Maqueta/Sidebar.vue como una más.
       *
       * La dirección, en inglés como el resto de rutas del panel
       * (`listings-manager`, `direct-bookings/settings`). La vieja en español,
       * `/paginas-web`, redirige para no romper los enlaces ya compartidos.
       */
      {
        path: "/websites",
        name: "PaginasWeb",
        component: () => import("@/views/sitiosWeb/PaginasWeb.vue"),
        meta: {
          title: "Página web",
          requiresAuth: true,
        },
      },
      { path: "/paginas-web", redirect: "/websites" },

      // {
      //   path: "availability-prices",
      //   name: "availabilityPrices",
      //   component: () =>
      //     import("@/views/Business/Reservas/AvailabilityPrices.vue"),
      // },
      {
        path: "messages-channel",
        name: "messageChannelPage",
        component: () => import("@/views/Business/message/index.vue"),
      },
      {
        path: "messages",
        name: "PageMensajes",
        component: () => import("@/views/Business/Mensajes/PageMensajes.vue"),
      },

      {
        path: "/channel-connect",
        name: "ChannelConnect",
        props: true,
        component: () => import("@/views/Business/channel/SelectOTA.vue"),
      },
      {
        path: "scheduled-checkins/bell",
        name: "configuracionReservas",
        component: () =>
          import("@/views/Business/Reservas/configuracionReserva.vue"),
      },
      {
        path: "scheduled-checkins/import",
        name: "configuracionImport",
        component: () =>
          import("@/views/Business/Reservas/configuracionReservaImport.vue"),
      },

      {
        path: "scheduled-checkins/:id/:reserva/booking",
        name: "ReservasID",
        props: true,
        component: () =>
          import("@/views/Business/Reservas/PageReservation.vue"),
      },

      {
        path: "waba_integration",
        name: "wabaIntegration",
        component: () => import("@/views/Business/WabaIntegration.vue"),
      },

      {
        path: "waba_integration/embedded-signup",
        name: "wabaIntegrationSignup",
        component: () => import("@/views/Business/menuIntegration.vue"),
      },

      {
        path: "properties",
        name: "Propiedades",
        component: () => import("@/views/Business/Propiedades/index.vue"),
      },

      {
        path: "properties/edition/:propiedad_id",
        name: "editionProperty",
        props: true,
        component: () =>
          import("@/views/Business/Propiedades/contenidoView.vue"),
        children: [
          {
            path: "name-property",
            name: "nameProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/NameProperty.vue"),
          },
          {
            path: "location-property",
            name: "locationProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/LocationProperty.vue"),
          },
          {
            path: "services-property",
            name: "serviceProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/ServiceProperty.vue"),
          },

          {
            path: "capacity-property",
            name: "capacityProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/CapacityProperty.vue"),
          },

          {
            path: "price-property",
            name: "priceProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/PriceProperty.vue"),
          },
          {
            path: "maintenance",
            name: "maintenance",
            props: true,
            component: () => import("@/components/Propiedades/Maintenance.vue"),
          },

          // Habitaciones
          {
            path: "room-types",
            name: "roomTypes",
            props: true,
            component: () => import("@/components/Propiedades/RoomTypes.vue"),
          },

          {
            path: "room-management",
            name: "roomManagement",
            props: true,
            component: () =>
              import("@/components/Propiedades/RoomManagement.vue"),
          },
          {
            path: "welcome-accommodation",
            name: "welcomeAccommodationProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/welcomeAccommodation.vue"),
          },
          {
            path: "image-settings",
            name: "imageSettings",
            props: true,
            component: () =>
              import("@/components/Propiedades/ImageSettings.vue"),
          },

          {
            path: "rates",
            name: "Rates",
            props: true,
            component: () => import("@/components/Propiedades/Rates.vue"),
          },

          {
            path: "description-property",
            name: "descriptionProperty",
            props: true,
            component: () =>
              import("@/components/Propiedades/DescriptionProperty.vue"),
          },
          {
            path: "cross-selling-property",
            name: "Ofertas",
            props: true,
            component: () => import("@/views/Business/Upselling/Ofertas.vue"),
          },

          {
            path: "rooms",
            name: "Habitaciones",
            props: true,
            component: () =>
              import("@/components/Propiedades/Habitaciones.vue"),
          },

          {
            path: "notifications",
            name: "Notifications",
            props: true,
            component: () =>
              import("@/components/Propiedades/Notificaciones.vue"),
          },
          {
            path: "qr-property",
            name: "QRPropiedad",
            props: true,
            component: () => import("@/components/Propiedades/QR.vue"),
          },
          {
            path: "seguridad-property",
            name: "SeguridadPropiedad",
            props: true,
            component: () => import("@/components/Propiedades/Seguridad.vue"),
          },
          {
            path: "identity-verification",
            name: "identityVerification",
            props: true,
            component: () =>
              import("@/components/Propiedades/VerifyIdentity.vue"),
          },
          {
            path: "smart-locks",
            name: "SmartLocks",
            props: true,
            component: () => import("@/components/Propiedades/SmartLocks.vue"),
          },

          {
            path: "guest-reviews",
            name: "Review",
            props: true,
            component: () =>
              import("@/components/Propiedades/valoracionHuespedes.vue"),
          },
          {
            path: "sync-calendar",
            name: "syncCalendar",
            props: true,
            component: () =>
              import("@/components/Propiedades/syncCalendar/index.vue"),
          },

         

          // {
          //   path: "welcome-accommodation",
          //   name: "welcomeAccommodation",
          //   props: true,
          //   component: () =>
          //     import("@/components/Propiedades/welcomeAccommodation.vue"),
          // },

          {
            path: "region-accommodation",
            name: "regionAccommodation",
            props: true,
            component: () =>
              import("@/components/Propiedades/regionAccommodation.vue"),
          },
        ],
      },

      {
        path: "/config_properties_notifications/:id/properties",
        name: "configUpselling",
        props: true,
        component: () =>
          import("@/views/Business/Propiedades/configNotifications.vue"),
      },

      {
        path: "service",
        name: "Servicios",
        component: () => import("@/views/Business/Upselling/Servicios.vue"),
      },

      {
        path: "invoices",
        name: "Invoices",
        component: () => import("@/views/Business/Facturas/index.vue"),
        children: [
          {
            path: "/select/suscriptions",
            name: "pageSubscription",
            component: () => import("@/views/Business/Subscription/index.vue"),
          },
          {
            path: "/manage/update-suscription",
            name: "updateSubscription",
            component: () =>
              import("@/views/Business/Facturas/updateSubscription.vue"),
          },

          {
            path: "invoicelist",
            name: "Invoicelist",
            component: () => import("@/views/Business/Facturas/Facturas.vue"),
          },
        ],
      },
      {
        path: "upselling/",
        name: "Upselling",
        component: () => import("@/views/Business/Upselling/index.vue"),
        children: [
          {
            path: "providers",
            name: "Proveedores",
            component: () =>
              import("@/views/Business/Upselling/Proveedores.vue"),
          },
          {
            path: "reports",
            name: "Informes",
            component: () => import("@/views/Business/Upselling/Informes.vue"),
          },
        ],
      },
    ],
    meta: {
      requiresAuth: true,
      roll: "empresa",
    },
  },

  // ! Rutas para la creacion de las propidades
  {
    path: "/",
    component: LayoutProperty,
    children: [
      {
        path: "create/properties",
        name: "firstCreatePropiedad",
        component: () =>
          import("@/views/Business/Propiedades/firstCreatePropiedad.vue"),
      },
    ],
  },
  // !

  {
    // =============================================================================
    // Panel Business Creacion y edicion
    // =============================================================================
    path: "/business/",
    component: maquetaCreate,
    children: [
      {
        path: "create/properties",
        name: "createPropiedad",
        component: () =>
          import("@/views/Business/Propiedades/createAccommodation.vue"),
      },
      {
        path: "create/services",
        name: "createServicio",
        component: () =>
          import("@/views/Business/Upselling/createServicio.vue"),
      },
      {
        path: "update/:id/service",
        name: "updateServicio",
        props: true,
        component: () =>
          import("@/views/Business/Upselling/updateServicio.vue"),
      },
      {
        path: "checkin/service/manager/system",
        name: "checkinManual",
        props: true,
        component: () => import("@/views/Business/Checkin/index.vue"),
      },
      {
        path: "checkin/service/previe/link/system",
        name: "checkinPrevieLink",
        props: true,
        component: () => import("@/views/Business/Checkin/previeCheckin"),
      },
      {
        path: "checkin/service/previe/system",
        name: "checkinPrevie",
        props: true,
        component: () => import("@/views/Business/Checkin/previeCheckin"),
      },
      // Ruta inicial del bot

      {
        path: "accommodation/manage-chat-bot-ia",
        name: "manageChatBot",
        props: true,
        component: () => import("@/views/Business/chatBot/index.vue"),
      },

      {
        path: "/calendar/bookings",
        name: "ReservationCalendar",
        props: true,
        component: () => import("@/views/Business/Reservas/Calendar.vue"),
      },
      {
        path: "/calendar-monthly/bookings",
        name: "monthlyCalendar",
        props: true,
        component: () =>
          import("@/views/Business/Reservas/MonthlyCalendar.vue"),
      },

      {
        path: "/hotel-calendar/bookings",
        name: "hotelReservationCalendar",
        props: true,
        component: () => import("@/views/Business/Reservas/HotelCalendar.vue"),
      },
      {
        // Venta por horas («modo motel») de los hoteles.
        path: "/hourly-calendar",
        name: "hourlyCalendar",
        component: () => import("@/views/Business/Reservas/HourlyCalendar.vue"),
      },
      {
        path: "availability-prices",
        name: "availabilityPrices",
        component: () =>
          import("@/views/Business/Reservas/AvailabilityPrices.vue"),
      },
    ],
    meta: {
      requiresAuth: true,
      roll: "empresa",
    },
  },

  {
    path: "/logout",
    name: "Logout",
    props: true,
    component: () => import("@/views/Logout.vue"),
  },

  // App rutas
  {
    path: "/checkin/customers/previe/:propiedad_id/",
    props: true,
    component: maquetaApp,
    children: [
      {
        path: "property",
        name: "WelcomeCheckin",
        props: true,
        component: () => import("@/views/App/welcome.vue"),
      },
      {
        path: "app/",
        name: "checkinPrevieLink2",
        props: true,
        component: () => import("@/views/App/index.vue"),
      },
      {
        path: "/services/:propiedad_id/:checkin_id/property",
        name: "ServiceProperty",
        props: true,
        component: () => import("@/views/App/Services/index.vue"),
      },
      {
        path: "/services/:propiedad_id/:service_id/:checkin_id/vew/",
        name: "seviceView",
        props: true,
        component: () => import("@/views/App/Services/viewService.vue"),
      },
    ],
    // Todo lo que cuelga de aqui lo abre el HUESPED (bienvenida, tienda,
    // ficha de un servicio). No es el panel: no debe salir nada del panel
    // encima —ni el lanzador de Guias ni el cajon de Novedades—, ni siquiera
    // cuando quien mira es un anfitrion con la sesion abierta.
    meta: { huesped: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// ── Permisos de equipo: mapa route name → función (espejo del backend) ──
// Si el sub-usuario no tiene la función, se le redirige a la primera permitida.
const ROUTE_FEATURE = {
  Dashboard: "dashboard",
  Analytics: "analytics",
  ReservationCalendar: "calendar",
  monthlyCalendar: "calendar",
  hotelReservationCalendar: "calendar",
  ReservationCalendarOta: "calendar",
  Reservas: "reservations",
  PageReservation: "reservations",
  Bookings: "bookings",
  GuestList: "guests",
  ClientesDirectorio: "guests",
  PageMensajes: "messages",
  messageChannelPage: "messages",
  InvoiceList: "invoicing",
  Servicios: "services",
  availabilityPrices: "channel_manager",
  ChannelConnect: "channel_manager",
  ChannelConnectOta: "channel_manager",
  AgentIAManager: "ai_agent",
  // «Recepción IA» (/business/ai-reception) lee `agent-ia/requests`, que la API
  // ya cierra con `ai_agent`. Sin esto, quien no tiene el permiso y entraba por
  // la URL veía una lista vacía (la API le contesta 403) en vez de ir a su inicio.
  AgentRequests: "ai_agent",
  ListingManager: "properties",
  firstCreatePropiedad: "properties",
  DirectBookingsSettings: "direct_bookings",
  Housekeeping: "housekeeping",
  HousekeepingCalendar: "housekeeping",
  HousekeepingProtocol: "housekeeping",
};

// Primera ruta que el usuario actual SÍ puede ver (destino de redirección).
// "Mi cuenta" (accountWelcome) no tiene función → siempre accesible (fallback).
function firstAllowedRouteName() {
  const order = [
    ["Dashboard", "dashboard"],
    ["Analytics", "analytics"],
    ["ReservationCalendar", "calendar"],
    ["monthlyCalendar", "calendar"],
    ["hotelReservationCalendar", "calendar"],
    ["Reservas", "reservations"],
    ["GuestList", "guests"],
    ["PageMensajes", "messages"],
    ["InvoiceList", "invoicing"],
    ["Servicios", "services"],
  ];
  for (const [name, feat] of order) {
    if (store.getters.hasFeature(feat)) return name;
  }
  return "accountWelcome";
}

router.beforeEach((to, from, next) => {
  console.log("soy navegacion router");
  console.log(to.matched.some((record) => record.meta.requiresAuth));
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      console.log("requiresAuth");
      next({ name: "Login" });
    } else {
      console.log("Validacion ruta");
      var TypeUser = to.matched.some(
        (record) => record.meta.roll == store.state.user.type,
      );
      console.log(store.state.user.type, "userType");
      console.log(
        to.matched.some((record) => record.meta.roll == store.state.user.type),
        "meta",
      );
      if (!TypeUser) {
        console.log("Entro en el typeUser");
        if (
          store.state.user.type == "admin" &&
          store.state.user.aplication == "wacheckin"
        ) {
          console.log("Ruta incorrecta");
          next({ name: "HomeManager" });
        }
        if (store.state.user.type == "empresa") {
          console.log("Ruta incorrecta");
          next({ name: firstAllowedRouteName() });
        }
      } else {
        // Tipo correcto → comprobar permisos de equipo (solo sub-usuarios).
        const su = store.state.subUser;
        /* Pantallas que son PONER UN PRECIO, no solo verlo: definir el catálogo de
           servicios o las tarifas. A quien no ve importes no se le dejan abrir, y no
           por pudor: si se le ocultara el campo obligatorio del precio, crearía
           servicios a 0 € que se venderían gratis. Los PEDIDOS de servicio sí los
           gestiona; lo que no hace es decidir cuánto cuestan. */
        const PONER_PRECIO = [
          "createServicio", "updateServicio",
          // El editor de disponibilidad y precio por día cuelga de «channel_manager»,
          // y el motor de reservas directas de «direct_bookings»: las dos las tiene,
          // así que sin esto entraba a poner tarifas, promociones y recargos.
          "availabilityPrices", "DirectBookingsSettings",
        ];
        if (su && store.getters.ocultaImportes && PONER_PRECIO.includes(to.name)) {
          next({ name: firstAllowedRouteName() });
          return;
        }

        const feature = su ? ROUTE_FEATURE[to.name] : null;
        if (feature && !store.getters.hasFeature(feature)) {
          const dest = firstAllowedRouteName();
          return next(dest && dest !== to.name ? { name: dest } : false);
        }
        console.log("Ruta correcta");
        next();
      }
    }
  } else {
    console.log("NO requiresAuth");
    next(); // make sure to always call next()!
  }
});

export default router;
